module.exports = __webpack_public_path__ + "img/translate.80f5fa56.webp";